import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { actions } from '@/reducers/flashMessages'

import Content from './Content'

const levelToClass = {
  alert: 'danger',
  error: 'danger',
  notice: 'success',
  notification: 'notification',
  success: 'success'
}

const flashClass = level => (
 `alert alert-dismissable alert-${levelToClass[level]}`
)

const FlashMessage = ({ message }) => {
  const dispatch = useDispatch()
  const { clearFlashMessages } = actions
  const { text, type } = message

  const handleOnClose = () => dispatch(clearFlashMessages())

  return (
    <div className={flashClass(type)} role='alert'>
      <Content handleOnClose={handleOnClose} text={text} />
    </div>
  )
}

export default FlashMessage

FlashMessage.propTypes = {
  message: PropTypes.shape({
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })
}
